import { render, staticRenderFns } from "./SimpleProduct.vue?vue&type=template&id=1537c66d&scoped=true&"
import script from "./SimpleProduct.vue?vue&type=script&lang=js&"
export * from "./SimpleProduct.vue?vue&type=script&lang=js&"
import style0 from "./SimpleProduct.vue?vue&type=style&index=0&id=1537c66d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1537c66d",
  null
  
)

export default component.exports